import React from "react";
import styled from "styled-components";
import { IonButton } from "@ionic/react";
import Alert from "../alert";

const AlertTitle = styled.div`
  font-weight: bold;
`;

const AlertSubtitle = styled.div`
  font-style: italic;
`;

const AlertContent = styled.div`
  padding: 16px 4px 8px 4px;
`;
const AlertMessage = styled.p`
  margin: 4px 0px 4px 0px;
`;
const ResendButton = styled(IonButton)``;

const ResendActionAlert = (props) => {
  return (
    <Alert color={props.type}>
      <AlertContent>
        <AlertTitle>{props.title}</AlertTitle>
        <AlertSubtitle>{props.subtitle}</AlertSubtitle>
        <AlertMessage>{props.message}</AlertMessage>
        <ResendButton onClick={props.buttonOnClick}>
          {props.buttonText}
        </ResendButton>
      </AlertContent>
    </Alert>
  );
};

export default ResendActionAlert;
